// Cada entrada liga uma key do JSON ao nome mostrado na tabela e à unidade
export const GENERIC_MAP = [
  {
    title: "Economic Value of Health Benefits",
    titleTooltip: "",
    tableTitle: "Metric",
    indicators: [
      {
        key: "totalBenefitsAccumulatedOverProjectLifeVSLBased",
        name: "Total benefits accumulated over project life (VSL-based)",
        unit: "USD",
      },
      {
        key: "totalBenefitsAccumulatedOverProjectLifeVOLYBased",
        name: "Total benefits accumulated over project life (VOLY-based)",
        unit: "USD",
      },
      {
        key: "discountedImplementationCosts",
        name: "Discount Implementation costs",
        unit: "USD",
      },
      {
        key: "benefitToCostRatio",
        name: "Benefit to cost ratio (VSL-based)",
        unit: "ratio",
      },
    ],
  },
  {
    title: "Emissions",
    titleTooltip: "Tooltip of emissions",
    tableTitle: "Benefit",
    indicators: [
      {
        key: "co2reduced",
        name: "CO₂ reduced",
        unit: "tonnes/year",
      },
      {
        key: "noxReduced",
        name: "NOx reduced",
        unit: "kilograms/year",
      },
      {
        key: "so2reduced",
        name: "SO₂ reduced",
        unit: "kilograms/year",
      },
      {
        key: "pm10reduced",
        name: "PM10 reduced",
        unit: "kilograms/year",
      },
      {
        key: "pm25reduced",
        name: "PM2.5 reduced",
        unit: "kilograms/year",
      },
    ],
  },
];
